/**
 * @flow
 * @relayHash 5dd47d9a3f5f1f5fec2ba09840dcf0b0
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type FolderWrapper_viewer$ref = any;
type HeartWrapper_viewer$ref = any;
export type FavoritesProviderQueryVariables = {|
  loadPortfolioData?: ?boolean,
  selectedItemIds?: ?$ReadOnlyArray<?string>,
  userIds?: ?$ReadOnlyArray<?string>,
  userId?: ?string,
  fetchUser?: ?boolean,
  shouldFillInFolder?: ?boolean,
|};
export type FavoritesProviderQueryResponse = {|
  +viewer: ?{|
    +isEnabledDesignerConnection: ?boolean,
    +user?: ?{|
      +isVerifiedTrade: ?boolean
    |},
    +$fragmentRefs: FolderWrapper_viewer$ref & HeartWrapper_viewer$ref,
  |}
|};
export type FavoritesProviderQuery = {|
  variables: FavoritesProviderQueryVariables,
  response: FavoritesProviderQueryResponse,
|};
*/


const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "loadPortfolioData",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "selectedItemIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "userIds",
    "type": "[String]",
    "defaultValue": ([]/*: any*/)
  },
  {
    "kind": "LocalArgument",
    "name": "userId",
    "type": "String",
    "defaultValue": ""
  },
  {
    "kind": "LocalArgument",
    "name": "fetchUser",
    "type": "Boolean",
    "defaultValue": false
  },
  {
    "kind": "LocalArgument",
    "name": "shouldFillInFolder",
    "type": "Boolean",
    "defaultValue": false
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": "isEnabledDesignerConnection",
  "name": "isEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "postContactSellerDesignerConnection",
      "type": "String!"
    }
  ],
  "storageKey": "isEnabled(key:\"postContactSellerDesignerConnection\")"
},
v2 = {
  "kind": "Variable",
  "name": "selectedItemIds",
  "variableName": "selectedItemIds",
  "type": null
},
v3 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds",
  "type": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId",
    "type": "String!"
  }
],
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isVerifiedTrade",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "Variable",
  "name": "itemIds",
  "variableName": "selectedItemIds",
  "type": "[String]"
},
v9 = {
  "kind": "Literal",
  "name": "portfolioTypes",
  "value": [
    "HEART"
  ],
  "type": "[PortfolioTypes]"
},
v10 = {
  "kind": "Variable",
  "name": "userIds",
  "variableName": "userIds",
  "type": "[String]"
},
v11 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "serviceId",
    "args": null,
    "storageKey": null
  },
  (v7/*: any*/)
],
v12 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "item",
  "storageKey": null,
  "args": null,
  "concreteType": "Item",
  "plural": false,
  "selections": (v11/*: any*/)
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FavoritesProviderQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "FolderWrapper_viewer",
            "args": [
              (v2/*: any*/),
              {
                "kind": "Variable",
                "name": "shouldFillInFolder",
                "variableName": "shouldFillInFolder",
                "type": null
              },
              (v3/*: any*/)
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "HeartWrapper_viewer",
            "args": [
              {
                "kind": "Variable",
                "name": "loadPortfolioData",
                "variableName": "loadPortfolioData",
                "type": null
              },
              (v2/*: any*/),
              (v3/*: any*/)
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v4/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "FavoritesProviderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "loadPortfolioData",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "heartItemMatches",
                "name": "portfolioItemMatches",
                "storageKey": null,
                "args": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "concreteType": "PortfolioItemV2",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "portfolioId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "portfolioItemId",
                    "args": null,
                    "storageKey": null
                  },
                  (v12/*: any*/),
                  (v7/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": "userPortfolios",
                "name": "portfolios",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1,
                    "type": "Int"
                  },
                  (v9/*: any*/),
                  (v10/*: any*/)
                ],
                "concreteType": "PortfoliosConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PortfoliosEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PortfolioV2",
                        "plural": false,
                        "selections": (v11/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "shouldFillInFolder",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": "folderItemMatches",
                "name": "portfolioItemMatches",
                "storageKey": null,
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "portfolioTypes",
                    "value": [
                      "FOLDER"
                    ],
                    "type": "[PortfolioTypes]"
                  },
                  (v10/*: any*/)
                ],
                "concreteType": "PortfolioItemV2",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v12/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": (v4/*: any*/),
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v7/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "FavoritesProviderQuery",
    "id": "app-buyer-finding/213.0.0-2019-04-23T14:40:24.662Z/FavoritesProviderQuery",
    "text": null,
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cfc652941823481c395a2fc9ad77f0e5';
module.exports = node;
